import { WHY_US } from "../data/content";
import { useReveal } from "../hooks/useReveal";
import * as Icons from "lucide-react";

export default function WhyUs() {
  const ref = useReveal();

  return (
    <section
      id="why"
      data-testid="whyus-section"
      className="relative py-24 lg:py-40 bg-[#FAFAFA]"
    >
      <div ref={ref} className="reveal max-w-[90rem] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <p className="overline mb-6 flex items-center gap-3">
            Why Choose Us
          </p>
          <h2
            data-testid="whyus-headline"
            className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-stone-900"
          >
            Exceptional outcomes are the
            <em className="italic text-[#4A6076]"> product of small precisions</em>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-14">
          {WHY_US.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Sparkles;
            return (
              <div
                key={w.title}
                data-testid={`whyus-item-${i}`}
                className="flex flex-col"
              >
                <span className="w-12 h-12 border border-stone-300 rounded-sm flex items-center justify-center text-[#4A6076] mb-6">
                  <Icon size={20} strokeWidth={1.4} />
                </span>
                <h3 className="font-serif-display text-2xl text-stone-900 leading-snug">
                  {w.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-stone-600">
                  {w.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
